import React, { useState, useEffect ,useRef} from "react";
import { Link } from "react-router-dom";
import EducationInformationModelPopup from "../../../components/modelpopup/EducationInformationModelPopup";
import ExperienceInformationPopup from "../../../components/modelpopup/ExperienceInformationPopup";
import PersonalInformationModelPopup from "../../../components/modelpopup/PersonalInformationModelPopup";
import EmploymentInformationModal from "../../../components/modelpopup/EmploymentInformationModelPopup";
import EmergencyContactModal from "../../../components/modelpopup/EmergencyContactModal";
import FamilyDependentPopup from "../../../components/modelpopup/FamilyDependentPopup";
import AddExitModelPopup from "../../../components/modelpopup/AddExitModelPopup";
import { Table } from "antd";

import moment from "moment";
import { toast } from "react-toastify";
import { useParams } from 'react-router-dom';



import { Avatar_02 } from "../../../Routes/ImagePath";
import { Avatar_01 } from "../../../Routes/ImagePath";
import { nodata } from "../../../Routes/ImagePath";

import {
 
  Avatar_05,
  Avatar_09,
  Avatar_10,
  Avatar_11,
  Avatar_12,
  Avatar_13,
  Avatar_16,
  eye,
  laptop,
} from "../../../Routes/ImagePath";
import { ListItem, ProjectDetails } from "./ProfileContent";
//import  EmploymentDetails  from "./EmploymentContent";




const ProfileTab = ({ userData, onUpdateUserData }) => {

  const [currentUserData, setCurrentUserData] = useState(userData);
  const [reportInfoData, setReportInfoData] = useState([]);
  const { userId } = useParams();
  const submitButtonRef = useRef(null);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const dateFormat = localStorage.getItem("dateFormat") || "MMM DD, YYYY";

  // Update currentUserData immediately when userData changes
  useEffect(() => {
    setCurrentUserData(userData);
  }, [userData]);

  const assests = [
    {
      id: 1,
      image: laptop,
      Name: "Laptop",
      AssetID: "AST - 001",
      AssignedDate: "22 Nov, 2022 10:32AM",
      img: Avatar_01,
      Assignee: "John Paul Raj\r\n  john@dreamguystech.com",
      Action: eye,
    },
    {
      id: 2,
      image: laptop,
      Name: "Laptop",
      AssetID: "AST - 002",
      AssignedDate: "22 Nov, 2022 10:32AM",
      img: Avatar_02,
      Assignee: "Vinod Selvaraj\r\n   vinod.s@dreamguystech.com",
      Action: eye,
    },
    {
      id: 3,
      image: laptop,
      Name: "Dell Keyboard",
      AssetID: "AST - 003",
      AssignedDate: "22 Nov, 2022 10:32AM",
      img: Avatar_05,
      Assignee: "Harika \r\n          harika.v@dreamguystech.com",
      Action: eye,
    },
    {
      id: 4,
      image: laptop,
      Name: "Logitech Mouse",
      AssetID: "AST - 0024",
      AssignedDate: "22 Nov, 2022 10:32AM",
      img: Avatar_09,
      Assignee: "Mythili\r\n            mythili@dreamguystech.com",
      Action: eye,
    },
    {
      id: 5,
      image: laptop,
      Name: "Laptop",
      AssetID: "AST - 005",
      AssignedDate: "22 Nov, 2022 10:32AM",
      img: Avatar_11,
      Assignee: "John Paul Raj\r\n         john@dreamguystech.com",
      Action: eye,
    },
    {
      id: 6,
      image: laptop,
      Name: "Laptop",
      AssetID: "AST - 006",
      AssignedDate: "22 Nov, 2022 10:32AM",
      img: Avatar_13,
      Assignee: "Vinod Selvaraj\r\n               vinod.s@dreamguystech.com",
      Action: eye,
    },
  ];



  const columns = [
    {
      title: "#",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
      width: "10%",
    },

    {
      title: "Name",
      dataIndex: "Name",
      render: (text, record) => (
        <span className="table-avatar">
          <Link to="/profile" className="avatar">
            <img alt="" src={record.image} />
          </Link>
          {text}
        </span>
      ),
      sorter: (a, b) => a.Name.length - b.Name.length,
    },

    {
      title: " AssetID",
      dataIndex: "AssetID",
      sorter: (a, b) => a.AssetID.length - b.AssetID.length,
    },
    {
      title: " AssignedDate",
      dataIndex: "AssignedDate",
      sorter: (a, b) => a.AssignedDate.length - b.AssignedDate.length,
    },

    {
      title: " Assignee",
      dataIndex: "Assignee",
      render: (text, record) => (
        <span className="table-avatar">
          <Link to="/profile" className="avatar">
            <img alt="" src={record.img} />
          </Link>
          {text}
        </span>
      ),
      sorter: (a, b) => a.Assignee.length - b.Assignee.length,
    },

    {
      title: "Action",
      dataIndex: "Action",
      render: (record) => (
        <span className="delete-table me-2">
          <Link to="/user-asset-details" className="table-actions d-flex">
            <img alt="" src={eye} />
          </Link>
        </span>
      ),
      sorter: (a, b) => a.Action.length - b.Action.length,
    },
  ];
















  useEffect(() => {
    const fetchReportInfoData = async () => {
      try {
        const response = await fetch(`${apiUrl}/employees/reportingdata/?empid=${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.ok) {
          const data = await response.json();
          setReportInfoData(data);
        } else {
          console.error("Failed to fetch reporting data");
        }
      } catch (error) {
        console.error("Error fetching reporting data:", error);
      }
    };

    fetchReportInfoData();
  }, [userId]);



  const handleUpdate = async (updatedData) => {
    try {
      // Create a refined data object
      const refinedData = {};
  
      Object.keys(updatedData).forEach(key => {
        if (updatedData[key] && typeof updatedData[key] === 'object' && updatedData[key].value !== undefined) {
          // Assign value to the main key
          refinedData[key] = updatedData[key].value;
          if (updatedData[key].label !== undefined) {
            refinedData[`${key}_name`] = updatedData[key].label;
          }
        } else {
          refinedData[key] = updatedData[key];
        }
      });
  
      // Make API call to update user data
      const response = await fetch(`${apiUrl}/employees/updateemployee/`, {
        method: "PUT", // Assuming you want to use a PUT request to update the data
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(refinedData),
      });
  
      if (response.ok) {
        // Update the state with the new data
        setCurrentUserData(refinedData);
        onUpdateUserData(refinedData); // Update userData in the parent component
  
        // Success toaster notification
        toast.success("User data updated successfully!", {
          position: "top-right"
        });

        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Trigger the click event
        }

      } else {
        // Handle error with response status text
        const errorData = await response.json(); // Parse the error response data
    
        toast.error(`Failed to update user data: ${errorData.error || response.statusText}`, {
          position: "top-right"
        });
      }
    } catch (error) {
      console.error("Error updating user data:", error);
  
      // Check if the error contains a response with a specific error message
      const errorMessage = error.response?.data?.error || error.message || "Error updating user data";
  
      toast.error(`Failed to update user data: ${errorMessage}`, {
        position: "top-right"
      });
    }
  };
  
  
  

  const capitalizeFirstChar = (string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const personalInfoDataL = [
    { id: 1, title: "First Name.", text: currentUserData.name || "-" },
    { id: 2, title: "Last Name.", text: currentUserData.lastname || "-" },
    { id: 3, title: "Father/Spouse Name", text: currentUserData.father_name || "-" },
    { id: 4, title: "Gender.", text: capitalizeFirstChar(currentUserData.gender) || "-" },
    { id: 5, title: "Birth Date.", text:  moment(currentUserData.date_of_birth).isValid() ? moment(currentUserData.date_of_birth).format(dateFormat) : "-"}, 
    ...(currentUserData.martial_status === "married" ? [{
      id: 6,
      title: "Wedding Date.",
      text: moment(currentUserData.wedding_date).isValid() ? moment(currentUserData.wedding_date).format(dateFormat) : "-"
    }] : []),
   
    { id: 6, title: "Religion", text: currentUserData.religion || "-" },
    { id: 7, title: "Nationality", text: currentUserData.nationality || "-" },
    { id: 10, title: "Phone", text: currentUserData.mobile || "-" },
    { id: 11, title: "Personal Email", text: currentUserData.personal_email || "-" },
    { id: 12, title: "Marital status", text: currentUserData.martial_status || "-" },
    { id: 13, title: "Blood Group", text: currentUserData.blood_group || "-" },
    { id: 14, title: "Present address", text: currentUserData.present_address || "-" },
    { id: 15, title: "Permanent address", text: currentUserData.permanent_address || "-" },
  ];


  const personalInfoDataR = [
    { id: 8, title: "Passport number", text: currentUserData.passport_number    || "-"  },
    { id: 9, title: "Visa  number", text: currentUserData.visa_number  || "-" },
    { id: 1, title: "PAN No", text: currentUserData.pan_no || "-"},
    { id: 2, title: "UAN No", text: currentUserData.uan_no || "-"},
    { id: 3, title: "EPF No", text: currentUserData.epf_no  || "-" },
    { id: 3, title: "Social Security No", text: currentUserData.social_security_number || "-" },
    { id: 4, title: "AADHAR Number", text: currentUserData.aadhar_no || "-" },
    { id: 5, title: "Bank Name", text: currentUserData.bank_name || "-" },
    { id: 6, title: "Bank A/c number", text: currentUserData.bank_account_number || "-"},
    { id: 7, title: "IFSC Code", text: currentUserData.ifsc_code || "-" },
    { id: 8, title: "Added By", text: currentUserData.created_name || "-"},  
    { id: 9, title: "Added On", text: moment(currentUserData.created).isValid() ? moment(currentUserData.created).format(dateFormat) : "-" },
    { id: 10, title: "Modified  By", text: currentUserData.modified_name || "-" },
    { id: 11, title: "Modified On", text: moment(currentUserData.modified).isValid() ? moment(currentUserData.modified).format(dateFormat) : "-" },
    
  ];
  
  const employmentInfoDataL = [
    { id: 1, title: "Employee ID", text: currentUserData.empcode    || "-"  },
    { id: 2, title: "Designation", text: currentUserData.designation_name   || "-" },
    { id: 3, title: "Department", text:  currentUserData.department_name   || "-" },
    { id: 4, title: "Date of Joining", text: moment(currentUserData.employee_doj).isValid() ? moment(currentUserData.employee_doj).format(dateFormat) : "-" },
    { id: 6, title: "Work Location", text: currentUserData.work_location   || "-" },
    { id: 7, title: "Shift", text: currentUserData.shift_name  || "-" },
    { id: 8, title: "Employment Type", text: capitalizeFirstChar(currentUserData.employment_type)   || "-"},
    { id: 9, title: "Employment Status", text:  capitalizeFirstChar(currentUserData.empstatus )  || "-" },
    { id: 10, title: "Date of Confirmation", text: moment(currentUserData.confirmation_date).isValid() ? moment(currentUserData.confirmation_date).format(dateFormat) : "-" },
    { id: 11, title: "Work Preference", text: capitalizeFirstChar(currentUserData.work_preference )  || "-"},
    { id: 12, title: "Reporting to", text:  currentUserData.reporting_name   || "-" },
    
   
  ];  



  const emergencyContactData = [
    { id: 1, title: "Name", text: currentUserData.emergency_contact || "-" },
    { id: 2, title: "Relationship", text: currentUserData.emergency_contact_relation || "-" },
    { id: 3, title: "Phone", text: currentUserData.emergency_contact_phone || "-" },
  ];
  



  const resigned = currentUserData.empstatus === "resigned";

  const exitData = [
    { id: 1, title: "Running on Notice", text: resigned ? "Yes" : "No" },
    {
      id: 2,
      title: "Resignation Date",
      text: resigned && moment(currentUserData.resignation_date).isValid()
        ? moment(currentUserData.resignation_date).format(dateFormat)
        : "-",
    },
    {
      id: 3,
      title: "Exit Date",
      text: resigned && moment(currentUserData.exit_date).isValid()
        ? moment(currentUserData.exit_date).format(dateFormat)
        : "-",
    },
    {
      id: 4,
      title: "Last Day at Work",
      text: resigned && moment(currentUserData.last_day_at_work).isValid()
        ? moment(currentUserData.last_day_at_work).format(dateFormat)
        : "-",
    },
    {
      id: 5,
      title: "Resignation Accepted",
      text: resigned ? (currentUserData.resignation_accepted ? "Yes" : "No") : "-",
    },
    {
      id: 6,
      title: "Notice Served",
      text: resigned ? (currentUserData.notice_served ? "Yes" : "No") : "-",
    },
  ];
  
  
  

  const [dependentData, setDependentData] = useState([]);

  const updateDependentData = (data) => {
    setDependentData(data);
  };

  const [educationData, setEducationData] = useState([]);

  const updateEducationData = (newData) => {
      setEducationData(newData);
  };

  const [experienceData, setExperienceData] = useState([]);

  const updateExperienceData = (newData) => {
    setExperienceData(newData);
  };


  return (
    <>
      <div className="tab-content">
        <div
          id="emp_profile"
          className="pro-overview tab-pane fade show active"
        >
  <div className="card profile-box flex-fill">
    <div className="card-body">
      {/* Personal Information Title (Display only once) */}
      <h3 className="card-title mb-4">
        {"Personal Informations "}
        <Link
          to="#"
          className="edit-icon"
          data-bs-toggle="modal"
          data-bs-target="#personal_info_modal"
        >
          <i className="fa fa-pencil" />
        </Link>
      </h3>
      <div className="row bordered-row">
        {/* First Column */}
        <div className="col-md-6">
          {/* Personal Information List */}
          <ul className="personal-info list-item">
            {personalInfoDataL.map((item, index) => (
              <ListItem
                key={index}
                id={item.id}
                title={item.title}
                text={item.text}
                
              />
            ))}
          </ul>
        </div>
        {/* Second Column */}
        <div className="col-md-6">
          {/* Personal Information List */}
          <ul className="personal-info list-item">
            {personalInfoDataR.map((item, index) => (
              <ListItem
                key={index}
                id={item.id}
                title={item.title}
                text={item.text}
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  </div>

          <div className="row">
     



            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Emergency Contact{" "}
                    <Link
                      to="#"
                      className="edit-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#emergency_contact_modal"
                    >
                      <i className="fa fa-pencil" />
                    </Link>
                  </h3>
                  <ul className="personal-info">
                    {emergencyContactData.map((item, index) => (
                      <ListItem
                        id={item.id}
                        key={index}
                        title={item.title}
                        text={item.text}
                      />
                    ))}
                  </ul>

                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Family Informations{" "}
                    <Link
                      to="#"
                      className="edit-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#family_dependent_popup"
                    >
                      <i className="fa fa-pencil" />
                    </Link>
                  </h3>
                  <div className="table-responsive">
                    <table className="table table-nowrap">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Relationship</th>
                          <th>Gender</th>
                          <th>DOB</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {dependentData.map((item) => (
                          <tr key={item.id}>
                            <td>{item.name}</td>
                            <td>{item.relationship}</td>
                            <td>{item.gender}</td>
                            <td>{item.date_of_birth}</td>
                            <td className="text-end">
                              <div className="dropdown dropdown-action">
                                <Link
                                  aria-expanded="false"
                                  data-bs-toggle="dropdown"
                                  className="action-icon dropdown-toggle"
                                  to="#"
                                >
                                  <i className="material-icons">more_vert</i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                  <Link to="#" className="dropdown-item">
                                    <i className="fa fa-pencil m-r-5" /> Edit
                                  </Link>
                                  <Link to="#" className="dropdown-item">
                                    <i className="fa fa-trash m-r-5" /> Delete
                                  </Link>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className="row">
            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Education Informations{" "}
                    <Link
                      to="#"
                      className="edit-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#education_info"
                    >
                      <i className="fa fa-pencil" />
                    </Link>
                  </h3>
                  <div className="experience-box">
                    <ul className="experience-list">

                      {educationData.map((item) => (
                          <li key={item.year}>
                          <div className="experience-user">
                            <div className="before-circle" />
                          </div>
                          <div className="experience-content">
                            <div className="timeline-content">
                              <Link to="/" className="name">
                                {item.degree}
                              </Link>
                              <div>{item.university}</div>
                              <div>{item.grade}</div>
                              <span className="time">{item.years}</span>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Work Experience{" "}
                    <Link
                      to="#"
                      className="edit-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#experience_info"
                    >
                      <i className="fa fa-pencil" />
                    </Link>
                  </h3>
                  <div className="experience-box">
                    <ul className="experience-list">
                      {experienceData.map((item) => (
                        <li key={item.id}>
                          <div className="experience-user">
                            <div className="before-circle" />
                          </div>
                          <div className="experience-content">
                            <div className="timeline-content">
                              <Link to="/" className="name">
                                {item.employer}
                              </Link>
                              <div>{item.job_title}</div>
                              <span className="time">{item.from_date}-{item.to_date}</span>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="emp_details" className="pro-overview tab-pane fade show">
  <div className="row bordered-row" style={{ display: "flex" }}>
    {/* First Column */}
    <div className="col-md-6" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
      {/* Personal Information */}
      <div className="card profile-box flex-fill" style={{ marginBottom: "10px" }}>
        <div className="card-body">
          <h3 className="card-title">
            Employment Details
            <Link
              to="#"
              className="edit-icon"
              data-bs-toggle="modal"
              data-bs-target="#employment_info_modal"
            >
              <i className="fa fa-pencil" />
            </Link>
          </h3>
          <ul className="personal-info list-item">
            {employmentInfoDataL.map((item, index) => (
              <ListItem
                key={index}
                id={item.id}
                title={item.title}
                text={item.text}
              />
            ))}
          </ul>
        </div>
      </div>
      {/* Exit */}
      <div className="card profile-box flex-fill">
        <div className="card-body">
          <h3 className="card-title">
            Exit
            <Link
              to="#"
              className="edit-icon"
              data-bs-toggle="modal"
              data-bs-target="#exit_info_modal"
            >
              <i className="fa fa-pencil" />
            </Link>
          </h3>
          <ul className="personal-info list-item">
            {exitData.map((item, index) => (
              <ListItem
                key={index}
                id={item.id}
                title={item.title}
                text={item.text}
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
    {/* Second Column */}
    <div className="col-md-6">
      {/* Direct Reports */}

<div className="card profile-box flex-fill">
  <div className="card-body">
    <h3 className="card-title">Direct Reports</h3>
    <div className="table-responsive">
      {reportInfoData.length > 0 ? (
        <table className="table table-nowrap">
          <tbody>
            {reportInfoData.map((item) => (
              <tr key={item.id}>
                <td>
                  <div className="profile-img">
                    <Link to={`/profile/${item.id}`} className="avatar">
                      <img src={item.gender === 'male' ? Avatar_01 : Avatar_02} alt="" />
                    </Link>
                  </div>
                </td>
                <td>{item.name}<br />{item.designation_name}</td>
                <td></td>
                <td>{item.phone}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="no-data">
          <img src={nodata} alt="" />

          <p>No team reports to {userData.name} {userData.lastname}.</p>
        </div>
      )}
    </div>
  </div>
</div>

    </div>
  </div>
</div>





        {/* Bank Statutory Tab */}
{/* /Assests Tab */}
<div className="tab-pane fade" id="emp_assets">
          <div className="table-responsive table-newdatatable">
            <Table
              columns={columns}
              dataSource={assests}
              className="table-striped"
              rowKey={(record) => record.id}
            />
          </div>
        </div>
        {/* /Bank Tab */}
        {/* Bank Statutory Tab */}
        {/*  Bank Tab */}
      </div>
      {/* Model Popup*/}
      <EducationInformationModelPopup educationData={educationData} updateEducationData={updateEducationData} />

      <FamilyDependentPopup
          dependentData={dependentData}
          onUpdate={updateDependentData}
        />

      <ExperienceInformationPopup
        experienceData={experienceData}
        updateExperienceData={updateExperienceData}
      />

      <EmploymentInformationModal userData={userData} onUpdate={handleUpdate}/>
      <PersonalInformationModelPopup userData={userData} onUpdate={handleUpdate}/>
      <EmergencyContactModal userData={userData} onUpdate={handleUpdate}/>

      <AddExitModelPopup exitData={userData} onUpdate={handleUpdate}/>



          </>
  );
};

export default ProfileTab;
